<!--
 * @Author: czj
 * @Date: 2025-04-14 14:50:45
 * @Description: pdf、svg，img 的父组件
 * @FilePath: \test-demo2\src\components\ImageCom\index.vue
-->
<template>
  <div>
    <SingleImgCom :node_data="raw_data"></SingleImgCom>
    <PictureCom :node_data="raw_data" :picture_files="picture_files"></PictureCom>
    <PdfCom :node_data="raw_data" :pdf_files="pdf_files"></PdfCom>
  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import PubSub from 'pubsub-js';
  import { separateFiles } from '@/utils/tool.js';

  import SingleImgCom from './SingleImgCom.vue';
  import PictureCom from './PictureCom.vue';
  import PdfCom from './PdfCom.vue';

  const emit = defineEmits([])
  const props = defineProps(['data', 'task_result']);

  const current_picture = ref({});
  const inlineGallery = ref(null);
  const is_load_gallery = ref(false);
  const pdf_files = ref(null);// pdf文件数据
  const picture_files = ref(null);// 图像文件数据

  const raw_data = ref(null);
  const node_data_token = ref(null);// 节点数据token
  const svg_save_token = ref(null);// svg保存token

  const initFileData = function () { // 初始化文件数据
    if (props.data && props.data.process_report && props.data.process_report.length > 0) {
      const title = props.data.title;
      const defaultVal = raw_data.value.process_report[0].default_val;
      if (defaultVal) {
        const { pdfFiles, pictureFiles, imgBase } = separateFiles(defaultVal);
        if (pictureFiles) {
          picture_files.value = pictureFiles;
          PubSub.publish(`files_${title}`, { pictureFiles, imgBase });
        } else {
          pdf_files.value = pdfFiles;
          PubSub.publish(`files_${title}`, { pdfFiles: { select_data: defaultVal.select_data, pdfFiles }, imgBase });
        };
      }
    }
  };


  // 使用 watch 监听 props 的字段变化
  watch(() => props.task_result, (newData, oldData) => {
    if (newData) {
      let title = props.data.title;
      let node_result = newData[title];
      if (node_result) {
        raw_data.value.process_report[0].default_val = node_result.data;
        initFileData();
      }
    };
  });
  //组件即将挂载
  onBeforeMount(() => {
    raw_data.value = props.data;
  });
  //组件已经挂载
  onMounted(() => {
    initFileData();
    node_data_token.value = PubSub.subscribe(props.data.title, (msg, data) => {
      raw_data.value.process_report[0].default_val = data.result.data;
      initFileData();
    });

    svg_save_token.value = PubSub.subscribe(`svg_save_callback_${props.data.title}`, (msg, data) => {
      console.log('svg_save_callbacksvg保存回调', data);
      initFileData();
    });

  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
    if (node_data_token.value) PubSub.unsubscribe(node_data_token.value);
    if (svg_save_token.value) PubSub.unsubscribe(svg_save_token.value);
  });
  //组件已经卸载
  onUnmounted(() => {
  });
</script>
<style scoped></style>